import type { ImportDriverErrorKey } from "../types";

export const ERROR_MAP: { label: string; key: ImportDriverErrorKey }[] = [
	{ label: "CPF inválido", key: "cpfInvalid" },
	{ label: "CPF já cadastrado", key: "cpfExists" },
	{ label: "Email inválido", key: "emailInvalid" },
	{ label: "Email já cadastrado", key: "emailExists" },
	{ label: "Veículo não encontrado", key: "vehicleNotFound" },
	{ label: "Veículo já vinculado", key: "vehicleIdExists" },
	{ label: "Usuário inativo", key: "userInactive" },
];
